import React from 'react';
import {ScenarioExecutionDTO} from 'hemwb-api';
import StatusIndicator from '../admin/externalization/common/StatusIndicator';
import {formatScenarioExecutionStatusValue} from '../../../store/scenarioExecution/utils';

const InstanceExecutionStatus: React.FC<{execution: ScenarioExecutionDTO}> = ({execution}) => {
  return <StatusIndicator status={formatScenarioExecutionStatusValue(execution?.status)} />;
};

export default InstanceExecutionStatus;
